import { render, staticRenderFns } from "./tipDialog.vue?vue&type=template&id=457c5f9c&scoped=true"
import script from "./tipDialog.vue?vue&type=script&lang=js"
export * from "./tipDialog.vue?vue&type=script&lang=js"
import style0 from "./tipDialog.vue?vue&type=style&index=0&id=457c5f9c&prod&lang=scss&scoped=true"
import style1 from "./tipDialog.vue?vue&type=style&index=1&id=457c5f9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c5f9c",
  null
  
)

export default component.exports